import { AttributeValue } from "../../library-js/dom-tools/AttributeValue";
import { ElementAttribute } from "../../library-js/dom-tools/ElementAttribute";
import { ContextMenu } from "./ContextMenu";

export abstract class ContextMenuCreator
{
  static readonly attribute = new ElementAttribute( "-context--menu" );

  abstract get value():AttributeValue;
  abstract create( e:Element ):ContextMenu;
}